import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '@/config/firebase';
import { OperationsUser, OperationsRole } from '@/models/user.model';

export interface OperationsUserSummary {
  id: string;
  fullName: string;
  role: OperationsRole | string;
}

export class OperationsUserService {
  static async getActiveUsers(): Promise<OperationsUserSummary[]> {
    const q = query(collection(db, 'operationsUsers'), where('status', '==', 'active'));
    const snapshot = await getDocs(q);
    const users = snapshot.docs.map((docSnap) => {
      const data = docSnap.data();
      const user: OperationsUser = {
        id: docSnap.id,
        email: data.email || '',
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        role: data.role as OperationsRole,
        status: data.status,
        department: data.department,
        phoneNumber: data.phoneNumber,
        createdAt: data.createdAt?.toDate() || new Date(),
        lastLogin: data.lastLogin?.toDate(),
        metadata: data.metadata,
      };
      return {
        id: user.id,
        fullName: `${user.firstName} ${user.lastName}`.trim() || user.email,
        role: user.role,
      };
    });

    return users.sort((a, b) => a.fullName.localeCompare(b.fullName));
  }
}
